import React from 'react';
import { MathJax } from 'better-react-mathjax';

// When the backend sends LaTeX with single backslashes (e.g. \frac) without
// double-escaping them in JSON, the JSON parser converts recognized escape
// sequences into control characters:
//   \f  → form feed (0x0C)  — breaks \frac, \forall, \flat
//   \b  → backspace (0x08)  — breaks \begin, \bar, \bf
//   \r  → carriage return   — breaks \right, \rho, \rightarrow (standalone \r only)
// This restores the backslash so MathJax can parse the LaTeX correctly.
function fixLatexEscapes(text) {
  if (typeof text !== 'string') return text;
  return text
    .replace(/\f/g, '\\f')       // form feed → \f  (\frac, \forall, …)
    .replace(/\x08/g, '\\b')     // backspace → \b  (\begin, \bar, …)
    .replace(/\r(?!\n)/g, '\\r'); // standalone CR → \r  (\right, \rho, …)
}

function MathText({ children, className, style }) {
  if (!children) return null;
  return (
    <MathJax className={className} style={style} dynamic>
      {fixLatexEscapes(children)}
    </MathJax>
  );
}

export default MathText;
